export default "__VITE_ASSET__8e17cafa__"